module.exports = __webpack_public_path__ + "img/780e5a1.jpg";